import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, InputNumber, Spin, Select, Input, Tabs, Space } from 'antd';
import { CheckCircleOutlined, HomeOutlined, CloseCircleOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, CopyOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import Message from '../../component/message/message';
import UploadModal from './uploadModal';
import CloneModal from './cloneModal';
import SelectProgModal from '../../component/selectProgModal/selectProgModal';
import './wilProgrammeSetup.css';
import CohortProgModal from './cohortProgModal';
import trans from './translation';
const { TabPane } = Tabs;
const { Option } = Select;

const WilProgrammeSetup = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [flag, setFlag] = useState("");
    const [paramModel, setParamModel] = useState({});
    const [deleteTipText, setDeleteTipText] = useState("");
    const [isUpload, setIsUpload] = useState(false);
    const [isClone, setIsClone] = useState(false);
    const [isSearchProgModal, setIsSearchProgModal] = useState(false);
    const [searchProgModel, setSearchProgModel] = useState({});
    const [isCohortProgModal, setIsCohortProgModal] = useState(false);
    const [cohortProgModel, setCohortProgModel] = useState({});
    const [progId, setProgId] = useState(null);
    const [academicList, setAcademicList] = useState([]);
    const [programmeParametersId, setProgrammeParametersId] = useState(null);
    const [options, setOptions] = useState([]);
    const [lastUpdatedDateNew, setLastUpdatedDateNew] = useState(null);
    const [isSearch, setIsSearch] = useState([]);
    const [cohortProgramme, setCohortProgramme] = useState("");
    const [disable, setDisable] = useState(false);
    const tableColumns = {
        cohortYear: 'cohoet_year',
        progCode: 'prog_code',
    }

    useEffect(() => {
        search(pageSize, 1, "N");
        academicSearch();
    }, []);


    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg, newModel) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            if (newModel) {
                model = JSON.parse(JSON.stringify({ ...searchModel, ...newModel }));
            } else {
                model = JSON.parse(JSON.stringify(searchModel));
            }
        }
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("programmeParameters/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTables(data?.object?.list)
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false))
    }
    const academicSearch = () => {
        let model = {}
        Base.callBackApi("programmeParameters/academicSearch", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setAcademicList(data?.object);
                let models = []
                for (let i = 0; i < data?.object.length; i++) {
                    models[i] = {
                        value: data.object[i].userId,
                        label: data.object[i].staffName + ' / ' + data.object[i].academicStaffAcctId
                    }
                }
                setOptions(models)
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        messageShowHandler();
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({});
        setFlag("add");
        setTabIndex("2");
        setCohortProgModel({})
        setDisable(false)
    }

    const cloneClose = (flag) => {
        setIsClone(false);
    }

    const download = () => {
        setIsUpload(true)
    }

    const uploadClose = (flag) => {
        setIsUpload(false);
    }

    const initForm = (model = {}, initEmptyFlag) => {
        form.resetFields();
        form.setFieldsValue({
            progCode: initEmptyFlag ? '' : model.progCode ?? '',
            progTitle: initEmptyFlag ? '' : model.progTitle ?? '',
            cohortYear: initEmptyFlag ? '' : model.cohortYear ?? '',
            programmeLeader: model.programmeLeaderId ?? '',
            moduleConvener: model.moduleConvenerId ?? '',
            academicSupervisor: model.academicSupervisor,
            status: model.status ?? '',
            assignment1LogWeight: model.assignment1LogWeight ?? '',
            assignment2FinalReportWeight: model.assignment2FinalReportWeight ?? '',
            assignment3OtherWeight: model.assignment3OtherWeight ?? '',
            wpaWeight: model.wpaWeight ?? '',
            wpaQuestion1Weight: model.wpaQuestion1Weight ?? '',
            wpaQuestion2Weight: model.wpaQuestion2Weight ?? '',
            wpaQuestion3Weight: model.wpaQuestion3Weight ?? '',
            wpaQuestion4Weight: model.wpaQuestion4Weight ?? '',
            wpaQuestion5Weight: model.wpaQuestion5Weight ?? '',
            wpaQuestion6Weight: model.wpaQuestion6Weight ?? '',
            wpaQuestion7Weight: model.wpaQuestion7Weight ?? '',
            wpaQuestion8Weight: model.wpaQuestion8Weight ?? '',
            wpaQuestion9Weight: model.wpaQuestion9Weight ?? '',
            wpaQuestion10Weight: model.wpaQuestion10Weight ?? '',
            wpaQuestion11Weight: model.wpaQuestion11Weight ?? '',
            wpaQuestion12Weight: model.wpaQuestion12Weight ?? '',
            wpaQuestion13Weight: model.wpaQuestion13Weight ?? '',
            programmeSpecificWpaQuestion9: model.programmeSpecificWpaQuestion9 ?? '',
            programmeSpecificWpaQuestion10: model.programmeSpecificWpaQuestion10 ?? '',
            programmeSpecificWpaQuestion11: model.programmeSpecificWpaQuestion11 ?? '',
            programmeSpecificWpaQuestion12: model.programmeSpecificWpaQuestion12 ?? '',
            programmeSpecificWpaQuestion13: model.programmeSpecificWpaQuestion13 ?? '',

            programmeSpecificWpaQuestion9Sc: model.programmeSpecificWpaQuestion9Sc ?? '',
            programmeSpecificWpaQuestion10Sc: model.programmeSpecificWpaQuestion10Sc ?? '',
            programmeSpecificWpaQuestion11Sc: model.programmeSpecificWpaQuestion11Sc ?? '',
            programmeSpecificWpaQuestion12Sc: model.programmeSpecificWpaQuestion12Sc ?? '',
            programmeSpecificWpaQuestion13Sc: model.programmeSpecificWpaQuestion13Sc ?? '',

            programmeSpecificWpaQuestion9Tc: model.programmeSpecificWpaQuestion9Tc ?? '',
            programmeSpecificWpaQuestion10Tc: model.programmeSpecificWpaQuestion10Tc ?? '',
            programmeSpecificWpaQuestion11Tc: model.programmeSpecificWpaQuestion11Tc ?? '',
            programmeSpecificWpaQuestion12Tc: model.programmeSpecificWpaQuestion12Tc ?? '',
            programmeSpecificWpaQuestion13Tc: model.programmeSpecificWpaQuestion13Tc ?? '',
            assignment1Weight: model.assignment1Weight ?? '',
            assignment2Weight: model.assignment2Weight ?? '',
            assignment3Weight: model.assignment3Weight ?? '',
            assignment4Weight: model.assignment4Weight ?? '',
            assignment5Weight: model.assignment5Weight ?? '',
            assignment6Weight: model.assignment6Weight ?? '',
            assignment7Weight: model.assignment7Weight ?? '',
            assignment8Weight: model.assignment8Weight ?? '',
            assignment9Weight: model.assignment9Weight ?? '',
            assignment10Weight: model.assignment10Weight ?? '',

        });
        setCohortProgModel({})
        if (initEmptyFlag) {
            setCohortProgramme('')
        } else {
            setCohortProgramme(model.progTitle)
        }
    }


    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true)
        Base.callBackApi("programmeParameters/delete", paramModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                search(pageSize, 1, "N");
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onSave = (values) => {
        messageShowHandler();
        let model = {
            ...values,
            cohortProgId: progId,
            programmeParametersId: programmeParametersId
        }

        setIsLoad(true)
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        if (flag == "edit") {

            Base.callBackApi("programmeParameters/update", { ...model, lastUpdatedDate: lastUpdatedDateNew }).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchById(data.object)
                    setFlag("edit");
                    errFrameShow("success", trans.saveSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        } else {
            Base.callBackApi("programmeParameters/insert", model).then((data) => {
                if ("SUCCESS" === data.msg) {
                    searchById(data.object)
                    setFlag("edit");
                    errFrameShow("success", trans.saveSuccess[Config.backLang]);
                } else {
                    errFrameShow("error", data.msg);
                }
            }).catch(err => { }).finally(() => setIsLoad(false));
        }
    }

    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        search(pageSize, current, "Y");
        setProgrammeParametersId(null)
    }

    const closeSearchProgModal = (flag, cohortProg) => {
        if (flag) {
            setSearchModel(model => {
                return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, } };
            });
            setSearchProgModel(cohortProg);
        }
        setIsSearchProgModal(false);
    }

    const closeCohortProgModal = (flag, cohortProg) => {
        if (flag) {
            if (isSearch) {
                setSearchModel(model => {
                    return { ...model, ...{ progName: cohortProg.progTitle, progCode: cohortProg.progCode, } };
                });
                setCohortProgModel(cohortProg);
            } else {
                form.setFieldsValue({
                    progId: cohortProg.progId,
                    progCode: cohortProg.progCode,
                    progTitle: cohortProg.progTitle,
                    cohortYear: cohortProg.cohortYear
                });
                setCohortProgModel(cohortProg);
                setProgId(cohortProg.cohortProgId)
                setCohortProgramme(cohortProg.progTitle)
            }
        }
        setIsCohortProgModal(false);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const update = (model, e) => {
        e.stopPropagation();
        messageShowHandler()
        setFlag("edit");
        searchById(model.programmeParametersId);
    }

    const duplicate = (model, e) => {
        e.stopPropagation();
        messageShowHandler()
        setFlag("duplicate");
        searchById(model.programmeParametersId, true);
    }

    const searchById = (programmeParametersId, initEmptyFlag) => {
        setIsLoad(true);
        Base.callBackApi("programmeParameters/searchById", programmeParametersId).then((data) => {
            if ("SUCCESS" === data.msg) {
                initForm(data?.object, initEmptyFlag)
                if (!initEmptyFlag) {
                    setDisable(data?.object.num > 0)
                    setProgId(data?.object?.cohortProgId)
                    setLastUpdatedDateNew(data?.object?.lastUpdatedDate)
                    setProgrammeParametersId(data?.object?.programmeParametersId)
                }
                setTabIndex("2");
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        messageShowHandler()
        setParamModel(model)
        setIsDeleteFrame(true);
        setDeleteTipText("Programme Code" + ":" + model.progCode + "")
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const validateRange = (value) => {
        if (parseFloat(value) > 1.00 || parseFloat(value) < 0) {
            return Promise.reject('Value error, Range should be between 0 and 1.');
        }
        return Promise.resolve();
    };

    const validateRange2 = (value, label) => {
        if (parseFloat(value) > 1.00 || parseFloat(value) < 0) {
            return Promise.reject('Value error, Range should be between 0 and 1.');
        }
        if (form.getFieldValue(label) && !value) {
            return Promise.reject('The value is required.');
        }
        return Promise.resolve();
    };
    const questionChange = (value, label1,label2,label3) => {
        if (!value) {
            form.validateFields([label1,label2,label3])
        }
    };

    const numFormatter = (value, label) => {
        let parts = value.toString().split('.');
        if (parts[1] && parts[1].length > 1) {
            parts[1] = parts[1].slice(0, 3);
        }
        form.setFieldsValue({
            [label]: parts.join('.'),
        })
        form.validateFields([label])
        return parts.join('.');
    };

    const validateForm = (values,label) => {
        if(label === "programmeSpecificWpaQuestion9" &&  (form.getFieldValue('programmeSpecificWpaQuestion9Tc') || form.getFieldValue('programmeSpecificWpaQuestion9Sc')) && !values ){
            return Promise.reject('Question 9 (English) is required.');
        }
        if(label === "programmeSpecificWpaQuestion9Tc" &&  (form.getFieldValue('programmeSpecificWpaQuestion9') || form.getFieldValue('programmeSpecificWpaQuestion9Sc')) && !values ){
            return Promise.reject('Question 9 (TC) is required.');
        }
        if(label === "programmeSpecificWpaQuestion9Sc" &&  (form.getFieldValue('programmeSpecificWpaQuestion9') || form.getFieldValue('programmeSpecificWpaQuestion9Tc')) && !values ){
            return Promise.reject('Question 9 (SC) is required.');
        }

        if(label === "programmeSpecificWpaQuestion10" &&  (form.getFieldValue('programmeSpecificWpaQuestion10Tc') || form.getFieldValue('programmeSpecificWpaQuestion10Sc')) && !values ){
            return Promise.reject('Question 10 (English) is required.');
        }
        if(label === "programmeSpecificWpaQuestion10Tc" &&  (form.getFieldValue('programmeSpecificWpaQuestion10') || form.getFieldValue('programmeSpecificWpaQuestion10Sc')) && !values ){
            return Promise.reject('Question 10 (TC) is required.');
        }
        if(label === "programmeSpecificWpaQuestion10Sc" &&  (form.getFieldValue('programmeSpecificWpaQuestion10') || form.getFieldValue('programmeSpecificWpaQuestion10Tc')) && !values ){
            return Promise.reject('Question 10 (SC) is required.');
        }
        if(label === "programmeSpecificWpaQuestion11" &&  (form.getFieldValue('programmeSpecificWpaQuestion11Tc') || form.getFieldValue('programmeSpecificWpaQuestion11Sc')) && !values ){
            return Promise.reject('Question 11 (English) is required.');
        }
        if(label === "programmeSpecificWpaQuestion11Tc" &&  (form.getFieldValue('programmeSpecificWpaQuestion11') || form.getFieldValue('programmeSpecificWpaQuestion11Sc')) && !values ){
            return Promise.reject('Question 11 (TC) is required.');
        }
        if(label === "programmeSpecificWpaQuestion11Sc" &&  (form.getFieldValue('programmeSpecificWpaQuestion11') || form.getFieldValue('programmeSpecificWpaQuestion11Tc')) && !values ){
            return Promise.reject('Question 11 (SC) is required.');
        }
        
        if(label === "programmeSpecificWpaQuestion12" &&  (form.getFieldValue('programmeSpecificWpaQuestion12Tc') || form.getFieldValue('programmeSpecificWpaQuestion12Sc')) && !values ){
            return Promise.reject('Question 12 (English) is required.');
        }
        if(label === "programmeSpecificWpaQuestion12Tc" &&  (form.getFieldValue('programmeSpecificWpaQuestion12') || form.getFieldValue('programmeSpecificWpaQuestion12Sc')) && !values ){
            return Promise.reject('Question 12 (TC) is required.');
        }
        if(label === "programmeSpecificWpaQuestion12Sc" &&  (form.getFieldValue('programmeSpecificWpaQuestion12') || form.getFieldValue('programmeSpecificWpaQuestion12Tc')) && !values ){
            return Promise.reject('Question 12 (SC) is required.');
        }

        if(label === "programmeSpecificWpaQuestion13" &&  (form.getFieldValue('programmeSpecificWpaQuestion13Tc') || form.getFieldValue('programmeSpecificWpaQuestion13Sc')) && !values ){
            return Promise.reject('Question 13 (English) is required.');
        }
        if(label === "programmeSpecificWpaQuestion13Tc" &&  (form.getFieldValue('programmeSpecificWpaQuestion13') || form.getFieldValue('programmeSpecificWpaQuestion13Sc')) && !values ){
            return Promise.reject('Question 13 (TC) is required.');
        }
        if(label === "programmeSpecificWpaQuestion13Sc" &&  (form.getFieldValue('programmeSpecificWpaQuestion13') || form.getFieldValue('programmeSpecificWpaQuestion13Tc')) && !values ){
            return Promise.reject('Question 13 (SC) is required.');
        }
        return Promise.resolve();
    };


    const columns = [
        {
            title: "Cohort",
            dataIndex: 'cohortYear',
            className: 'tableWidth8',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'cohortYear') },
        },
        {
            title: "Programme Code",
            dataIndex: 'progCode',
            className: 'tableWidth18',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progCode') },
        },
        {
            title: "Programme Name",
            dataIndex: 'progTitle',
            className: 'tableWidth15',
        },
        {
            title: "Programme Leader",
            dataIndex: 'programmeLeaderName',
            className: 'tableWidth15',
        },
        {
            title: "Module Convener",
            dataIndex: 'moduleConvenerName',
            className: 'tableWidth15',
        },
        {
            title: "Academic Supervisor",
            dataIndex: 'academicSupervisors',
            className: 'tableWidt29',
        },
        {
            title: "Operation",
            dataIndex: '',
            fixed: 'right',
            className: ' sysControls',
            width: 300,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => duplicate(record, e)} hidden={Config.funcInfo.canInsert === "N"}><CopyOutlined /> Duplicate</div>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> Edit</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> Delete</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> Log</div>
            </div>
        },
    ];

    return (
        <div id="container" className="template wilProgrammeSetup">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab="List">
                            <div className='sysRow'>
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme </div>
                                    <div className="sysButtonSearchInput">
                                        <Input type="text" value={searchModel.progCode || ''} disabled
                                            placeholder="Programme "
                                            onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                            onChange={(e) => searchChange('progCode', e.target.value)} />
                                    </div>
                                    <Button className="sysBtn btnBlue" onClick={() => { setIsCohortProgModal(true); setIsSearch(true) }}>Select</Button>
                                    {searchModel.progName && <div style={{ marginLeft: '10px' }}>{searchModel.progName}</div>}
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Programme Leader</div>
                                    <div className="sysSerchInput">
                                        <Select className='sysSelect'
                                            value={searchModel.programmeLeaderId || ''}
                                            onChange={(value) => searchChange('programmeLeaderId', value)}
                                        >
                                            <Option></Option>
                                            {academicList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName + ' / ' + item.academicStaffAcctId}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Module Convener</div>
                                    <div className="sysSerchInput">
                                        <Select className='sysSelect'
                                            value={searchModel.moduleConvenerId || ''}
                                            onChange={(value) => searchChange('moduleConvenerId', value)}
                                        >
                                            <Option></Option>
                                            {academicList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName + ' / ' + item.academicStaffAcctId}</Option>)}
                                        </Select>
                                    </div>
                                </div>
                                <div className='sysCol'>
                                    <div className="sysTitle">Academic Supervisor</div>
                                    <div className="sysSerchInput">
                                        <Select className='sysSelect'
                                            value={searchModel.academicSupervisorId || ''}
                                            onChange={(value) => searchChange('academicSupervisorId', value)}
                                        >
                                            <Option></Option>
                                            {academicList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName + ' / ' + item.academicStaffAcctId}</Option>)}
                                        </Select>

                                    </div>
                                </div>
                                <div className='sysSearchButton'>
                                    <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                    <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="buttonRelative">
                                <Button className='sysBtn btnBlue' type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>Add</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    // rowSelection={rowSelection} //选择
                                    rowKey="programmeParametersId"
                                    scroll={{ x: 1430 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,            //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,         //当前页
                                        pageSize: pageSize,       //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab={"Programme Parameters by Cohort"} key="2" forceRender={true}>
                            <Form form={form} onFinish={onSave}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput mustFill">Programme</div>
                                        <div className={!disable ? "sysInput sysButtonInput" : "sysInput"} >
                                            <Form.Item
                                                name="progCode"
                                                rules={[
                                                    { required: true, message: trans.programmeCodeIsNoNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder="Programme Code" maxLength={50} disabled />
                                            </Form.Item>
                                        </div>
                                        {
                                            !disable &&
                                            <Button className="sysBtn btnBlue" onClick={() => { setIsCohortProgModal(true); setIsSearch(false) }}>Select</Button>
                                        }

                                        <div style={{ marginLeft: '10px' }}>{cohortProgramme}</div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Cohort</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="cohortYear"
                                            >
                                                <Input type="text" placeholder="Cohort" maxLength={4} disabled />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Module Convener</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="moduleConvener"
                                            >
                                                <Select className='sysSelect'>
                                                    <Option></Option>
                                                    {academicList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName + ' / ' + item.academicStaffAcctId}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Programme Leader</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="programmeLeader"
                                            >
                                                <Select className='sysSelect'>
                                                    <Option></Option>
                                                    {academicList.map((item) => <Option key={item.userId} value={item.userId}>{item.staffName + ' / ' + item.academicStaffAcctId}</Option>)}
                                                </Select>

                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">Academic Supervisor</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="academicSupervisor"
                                            >
                                                <Select
                                                    mode="multiple"
                                                    allowClear
                                                    style={{
                                                        width: '100%',
                                                    }}
                                                    placeholder="Academic Supervisor"
                                                    options={options}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='wilProgrammeSetupBox'>
                                    <h4 className='wilProgrammeSetupBlueBoxTitle3'>Assignment WPA Weighting</h4>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 1 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment1Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 1 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment1Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 2 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment2Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 2 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment2Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 3 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment3Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 3 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment3Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 4 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment4Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 4 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment4Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 5 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment5Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 5 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment5Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 6 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment6Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 6 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment6Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 7 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment7Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 7 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment7Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 8 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment8Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 8 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment8Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 9 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment9Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 9 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment9Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Assignment 10 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="assignment10Weight"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Assignment 10 Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "assignment10Weight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">WPA Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaWeight"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'WPA Weighting is required.',
                                                        },
                                                        {
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="WPA Weighting" className='InputNumberInput' disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaWeight")
                                                        }
                                                        maxLength={5}
                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }}
                                                    />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='wilProgrammeSetupBox'>
                                    <h4 className='wilProgrammeSetupBlueBoxTitle3'>Programme Specific WPA Questions and Weighting</h4>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 9 (English)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion9"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion9")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 9 (English)" disabled={disable} maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion9Weight","programmeSpecificWpaQuestion9Tc","programmeSpecificWpaQuestion9Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 9 (TC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion9Tc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion9Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 9 (TC)" disabled={disable} maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion9Weight","programmeSpecificWpaQuestion9","programmeSpecificWpaQuestion9Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 9 (SC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion9Sc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion9Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 9 (Sc)" disabled={disable} maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion9Weight","programmeSpecificWpaQuestion9","programmeSpecificWpaQuestion9Tc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 9 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion9Weight"
                                                    rules={[
                                                        {
                                                            required: false, validator: (rule, value) => validateRange2(value, "programmeSpecificWpaQuestion9")
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 9 Weighting" disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion9Weight")
                                                        }
                                                        maxLength={5}
                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 10 (English)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion10"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion10")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 10 (English)" disabled={disable} maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion10Weight","programmeSpecificWpaQuestion10Tc","programmeSpecificWpaQuestion10Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 10 (TC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion10Tc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion10Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 10 (TC)" disabled={disable} maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion10Weight","programmeSpecificWpaQuestion10","programmeSpecificWpaQuestion10Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 10 (SC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion10Sc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion10Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 10 (SC)" disabled={disable} maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion10Weight","programmeSpecificWpaQuestion10Tc","programmeSpecificWpaQuestion10")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 10 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion10Weight"
                                                    rules={[
                                                        {
                                                            required: false, validator: (rule, value) => validateRange2(value, "programmeSpecificWpaQuestion10")
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 10 Weighting" disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion10Weight")
                                                        }
                                                        maxLength={5}
                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 11 (English)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion11"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion11")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" disabled={disable} placeholder="Question 11 (English)" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion11Weight","programmeSpecificWpaQuestion11Sc","programmeSpecificWpaQuestion11Tc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 11 (TC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion11Tc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion11Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" disabled={disable} placeholder="Question 11 (TC)" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion11Weight","programmeSpecificWpaQuestion11Sc","programmeSpecificWpaQuestion11")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 11 (SC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion11Sc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion11Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" disabled={disable} placeholder="Question 11 (SC)" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion11Weight","programmeSpecificWpaQuestion11","programmeSpecificWpaQuestion11Tc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 11 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion11Weight"
                                                    rules={[
                                                        {
                                                            required: false, validator: (rule, value) => validateRange2(value, "programmeSpecificWpaQuestion11")
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 11 Weighting" disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion11Weight")
                                                        }
                                                        maxLength={5}

                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 12 (English)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion12"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion12")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 12 (English)" disabled={disable} maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion12Weight","programmeSpecificWpaQuestion12Tc","programmeSpecificWpaQuestion12Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 12 (TC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion12Tc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion12Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 12 (TC)" disabled={disable} maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion12Weight","programmeSpecificWpaQuestion12","programmeSpecificWpaQuestion12Sc")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 12 (SC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion12Sc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion12Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 12 (SC)" disabled={disable} maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion12Weight","programmeSpecificWpaQuestion12Tc","programmeSpecificWpaQuestion12")} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 12 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion12Weight"
                                                    rules={[
                                                        {
                                                            required: false, validator: (rule, value) => validateRange2(value, "programmeSpecificWpaQuestion12")
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 12 Weighting" disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion12Weight")
                                                        }
                                                        maxLength={5}

                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 13 (English)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion13"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion13")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 13 (English)" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion13Weight","programmeSpecificWpaQuestion13Tc","programmeSpecificWpaQuestion13Sc")}  disabled={disable} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 13 (TC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion13Tc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion13Tc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 13 (TC)" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion13Weight","programmeSpecificWpaQuestion13","programmeSpecificWpaQuestion13Sc")} disabled={disable} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 13 (SC)</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="programmeSpecificWpaQuestion13Sc"
                                                    rules={[
                                                        {
                                                            required: false,
                                                            validator: (rule, value) => validateForm(value,"programmeSpecificWpaQuestion13Sc")
                                                        },
                                                    ]}
                                                >
                                                    <Input type="text" placeholder="Question 13 (SC)" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion13Weight","programmeSpecificWpaQuestion13Tc","programmeSpecificWpaQuestion13")} disabled={disable} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput">Question 13 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion13Weight"
                                                    rules={[
                                                        {
                                                            required: false, validator: (rule, value) => validateRange2(value, "programmeSpecificWpaQuestion13")
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 13 Weighting"
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion13Weight")
                                                        }
                                                        maxLength={5} disabled={disable}

                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='wilProgrammeSetupBox'>
                                    <h4 className='wilProgrammeSetupBlueBoxTitle3'>WPA Questions Weighting</h4>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">Question 1 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion1Weight"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Question 1 Weighting is required.'
                                                        },
                                                        {
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 1 Weighting" className='InputNumberInput'
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion1Weight")
                                                        }
                                                        maxLength={5}
                                                        disabled={disable}

                                                        onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">Question 2 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion2Weight"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Question 2 Weighting is required.'
                                                        },
                                                        {
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 2 Weighting" disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion2Weight")
                                                        }
                                                        maxLength={5}

                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">Question 3 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion3Weight"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Question 3 Weighting is required.'
                                                        },
                                                        {
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 3 Weighting" disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion3Weight")
                                                        }
                                                        maxLength={5}

                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">Question 4 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion4Weight"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Question 4 Weighting is required.'
                                                        },
                                                        {
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 4 Weighting" disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion4Weight")
                                                        }
                                                        maxLength={5}

                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">Question 5 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion5Weight"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Question 5 Weighting is required.'
                                                        },
                                                        {
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 5 Weighting" disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion5Weight")
                                                        }
                                                        maxLength={5}

                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">Question 6 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion6Weight"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Question 6 Weighting is required.'
                                                        },
                                                        {
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 6 Weighting" disabled={disable}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion6Weight")
                                                        }
                                                        maxLength={5}

                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sysRow'>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">Question 7 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion7Weight"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Question 7 Weighting is required.'
                                                        },
                                                        {
                                                        validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 7 Weighting" disabled={disable}
                                                        maxLength={5}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion7Weight")
                                                        }
                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='sysCol'>
                                            <div className="sysParam sysParamInput mustFill">Question 8 Weighting</div>
                                            <div className="sysInput">
                                                <Form.Item
                                                    name="wpaQuestion8Weight"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Question 8 Weighting is required.'
                                                        },
                                                        {
                                                            validator: (rule, value) => validateRange(value)
                                                        },
                                                    ]}
                                                >
                                                    <InputNumber placeholder="Question 8 Weighting" disabled={disable}
                                                        maxLength={5}
                                                        formatter={(value) =>
                                                            numFormatter(value, "wpaQuestion8Weight")
                                                        }
                                                        className='InputNumberInput' onKeyPress={(e) => { if (e.key === '-' || e.key === 'e') { e.preventDefault() } }} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" htmlType="submit" icon={<CheckCircleOutlined />}>Save</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>Cancel</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
                {isUpload && <UploadModal onClose={uploadClose} />}
                {isClone && <CloneModal onClose={cloneClose} />}
                {isSearchProgModal && <SelectProgModal onClose={closeSearchProgModal} progModel={searchProgModel} />}
                {isCohortProgModal && <CohortProgModal onClose={closeCohortProgModal} progModel={cohortProgModel} />}
            </div>
        </div>
    )

}

export default WilProgrammeSetup;